/** Valores de statusSolicitacao retornados pela API. */
export class StatusSolicitacao {
  static readonly EM_PREENCHIMENTO = 'EM_PREENCHIMENTO';
  static readonly AGUARDANDO_ESCOLHA_INSTITUTO = 'AGUARDANDO_ESCOLHA_INSTITUTO';
  static readonly AGUARDANDO_DADOS_CADASTRAIS = 'AGUARDANDO_DADOS_CADASTRAIS';
  static readonly AGUARDANDO_TIPO_IR = 'AGUARDANDO_TIPO_IR';
  static readonly AGUARDANDO_ENVIO_DOCUMENTOS = 'AGUARDANDO_ENVIO_DOCUMENTOS';
  static readonly AGUARDANDO_VALIDACAO_DOCUMENTOS = 'AGUARDANDO_VALIDACAO_DOCUMENTOS';
  static readonly AGUARDANDO_REENVIO = 'AGUARDANDO_REENVIO_DOCUMENTOS';
  static readonly AGUARDANDO_REVISAO = 'AGUARDANDO_REVISAO';
  static readonly AGUARDANDO_ASSINATURA_TERMO = 'AGUARDANDO_ASSINATURA_TERMO';
  static readonly FINALIZADO = 'FINALIZADO';
  static readonly CANCELADO = 'CANCELADO';
}
